import {Component, input, output} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-sad-wineglass-icon',
  templateUrl: './sad-wineglass-icon.component.html',
  styleUrls: ['./sad-wineglass-icon.component.scss'],
  imports: [
    NgOptimizedImage
  ]
})
export class SadWineglassIconComponent {

  readonly text = input<string>();
  readonly buttonText = input<string>();
  readonly blackWineglass = input<boolean>(false);
  readonly width = input<number>(200);
  readonly height = input<number>(200);
  readonly buttonClick = output();

}
